import * as signalR from '@microsoft/signalr';
import * as fn from './uiFunctions';

const HUB_URL = `${fn.getBaseURL()}apiv3/notifyhub`;

let connection = null;
let startPromise = null;

const createConnection = function () {
    return new signalR.HubConnectionBuilder()
        .withUrl(HUB_URL, { withCredentials: true })
        .withAutomaticReconnect()
        .build();
};

const startConnection = async function () {
    if (connection) {
        if (connection.state === signalR.HubConnectionState.Connected) {
            return connection;
        }

        if (startPromise) {
            await startPromise;
            return connection;
        }
    }

    if (!connection) {
        connection = createConnection();

        connection.onreconnecting((error) => {
            console.log('SignalR reconnecting', error);
        });

        connection.onreconnected((connectionId) => {
            console.log('SignalR reconnected', connectionId);
        });

        connection.onclose((error) => {
            console.log('SignalR closed', error);
            startPromise = null;
        });
    }

    startPromise = connection.start()
        .then(() => {
            console.log('SignalR connected', HUB_URL);
            return connection;
        })
        .catch((error) => {
            console.log('SignalR connection failed', error);
            throw error;
        })
        .finally(() => {
            startPromise = null;
        });

    await startPromise;

    return connection;
};

const subscribe = function (eventName, callback) {
    if (!eventName || !callback) return;

    if (!connection) {
        connection = createConnection();
    }

    connection.off(eventName, callback);
    connection.on(eventName, callback);
};

const unsubscribe = function (eventName, callback) {
    if (!connection || !eventName || !callback) return;

    connection.off(eventName, callback);
};

export { startConnection, subscribe, unsubscribe };
